<script>
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */

  import OttoUp from './OttoUp.svelte';
  import EnergyEfficiency from './EnergyEfficiency.svelte';
  import BenefitBadge from './BenefitBadge.svelte';
  import Sustainability from './Sustainability.svelte';
  import { key as featureWidthAlignmentWithCinemas } from '../context/featureWidthAlignmentWithCinemas.js';
  import { getContext } from 'svelte';

  /*                */
  let {
    variation,
    pricing,
    minimumOrderValueEligible = false,
    isMainVariation = false,
    featuresState = {},
    tableTracking
  } = $props();

  const showBottomBenefitBadge = variation.benefitId && variation.customerBenefitBadge;

  const showEnergyEfficiency =
    Array.isArray(variation.energyEfficiencyClasses) &&
    variation.energyEfficiencyClasses.length >= 1;

  const { widthAmount } = getContext(featureWidthAlignmentWithCinemas);
  const columnHorizontalPaddings = 32;
  const width = `${widthAmount - columnHorizontalPaddings}px`;
</script>

<div style:width class="reco_comparison__information-container">
  <div class="reco_comparison__original-price">
    {#if pricing.originalPricePrefix}
      <span class="reco_comparison__uvp-string oc-copy-100" role="tabpanel">
        {pricing.originalPricePrefix}
      </span>
    {/if}
    {#if pricing.originalPrice}
      <span
        class="reco_comparison__nowrap reco_comparison__price-line-through oc-copy-100"
        role="tabpanel">
        {pricing.originalPrice}
      </span>
    {/if}
  </div>
  {#if !variation.highlightText && !pricing.retailPricePrefix}
    <span
      class="reco_comparison__retail-price reco_comparison__nowrap oc-headline-50"
      class:reco_comparison__price-red={pricing.originalPrice}
      role="tabpanel">{pricing.retailPrice}</span>
  {/if}
  {#if variation.highlightText || pricing.retailPricePrefix}
    <span
      class="oc-headline-50 reco_comparison__retail-price"
      class:reco_comparison__price-red={pricing.originalPrice}
      role="tabpanel">
      {#if pricing.retailPricePrefix}{pricing.retailPricePrefix}{/if}
      <span
        class="oc-headline-50 reco_cinema__nowrap"
        class:reco_comparison__price-red={pricing.originalPrice}
        role="tabpanel">{pricing.retailPrice}</span>
      {#if variation.highlightText}<div>{variation.highlightText}</div>{/if}
    </span>
  {/if}

  {#if pricing.unitPrice}
    <div class="reco_comparison__price-per-unit oc-headline-10">
      <span role="tabpanel"> {pricing.unitPrice} </span>
    </div>
  {/if}
  {#if showBottomBenefitBadge}
    <BenefitBadge
      benefitDiscountValuePercent={variation.customerBenefitBadge}
      benefitId={variation.benefitId} />
  {/if}
  <OttoUp {minimumOrderValueEligible} />
  {#if showEnergyEfficiency}
    <EnergyEfficiency energyEfficiencyClasses={variation.energyEfficiencyClasses} />
  {/if}
  <Sustainability
    labels={variation.sustainabilities}
    variationId={variation.id}
    {isMainVariation}
    baseDetailViewUrl={variation.links
      ? variation.links['o:base-detail-view-url']?.href
      : undefined}
    variationDetailViewUrl={variation.links
      ? variation.links['o:variation-detail-view-url']?.href
      : undefined}
    {featuresState}
    {tableTracking} />
</div>

<style lang="scss">
  :root {
    --padding_within_cell: 4px;
  }

  .reco_comparison__information-container {
    text-align: left;
    overflow: hidden;
    max-width: 100%;
    margin-top: var(--oc-semantic-spacing-100);
  }

  .reco_comparison__nowrap {
    white-space: nowrap;
  }

  .reco_comparison__uvp-string {
    padding-right: var(--padding_within_cell);
  }

  .reco_comparison__retail-price {
    display: inline-block;
  }

  .reco_comparison__price-line-through {
    padding-right: var(--padding_within_cell);
    text-decoration: line-through;
  }

  .reco_comparison__price-red {
    color: var(--oc-semantic-color-brand);
  }

  .reco_comparison__price-per-unit {
    padding: 4px;
    color: var(--oc-base-color-grey-400);
  }
</style>
